import { RxCross1 } from "react-icons/rx";
import { useQuery } from "react-query";
import { QuizAPI } from "../../Api/Quiz";
import { Spinner } from "react-bootstrap";
import { isEmpty } from "lodash";
import EmptyContainer from "../CustomComponent/EmptyContainer";
import ContentLoader from "../Loader/ContentLoader";

const InviteListModal = ({ setIsOpen, modalData }) => {

    const quiz = QuizAPI();

    const {
        data,
        isLoading,
        isError,
        error,
    } = useQuery({
        queryKey: ["quiz-invite", modalData.id],
        queryFn: async () => {
            const response = await quiz.getInvitedUser(modalData.id);
            return response.data;
        },
    });


    return (
        <div className="invite-modal-content">
            {isLoading ? (
                <ContentLoader color="dark" />
            ) : (isEmpty(data) || isError) ? (
                <EmptyContainer text="No invited user found" iconColor="dark" textClasses="text-dark" />
            ) :
                <div className="tag-container">
                    {
                        data.map((item, index) => {
                            return <div key={index} className="tag">
                                {item.email}
                            </div>
                        })
                    }
                </div>
            }
        </div>
    );
};

export default InviteListModal;
